import React from 'react';
import LegalPage from './LegalPage';
import { cookiesContent } from '../data/legalContent';

const Cookies = () => (
  <LegalPage title="Cookie Policy" eyebrow="Metaxu One Private Limited" content={cookiesContent} />
);

export default Cookies;
